import {IdDocument} from "../components/loan-applications/loan-application/steps/customer-data/documents/id-document.model"
import {Applicant} from "../components/loan-applications/loan-application/steps/customer-data/customer-data-form.model"

export const getApplicantIdDocuments = (documents: IdDocument[], applicant: Applicant) =>
  documents.filter((document) => document.applicantId === applicant.id);